/**
 * Helper function for abbreviating large numbers (i.e. 1000 => 1k).
 */
export const abbrevNumber = (val: number): string => Intl.NumberFormat('en-US', { notation: 'compact' }).format(val);

/**
 * Helper function for formatting large numbers for readability (i.e. 100000 => 100,000).
 */
export const prettyNumber = (val: number): string => Intl.NumberFormat('en-US').format(val);

const FORMAT_COUNT_LIMIT_DEFAULT = 10_000;

/**
 * If the count is >= the limit, we display it like "10k" instead of "10,000".
 * If the count is less than the limit, we display it as is, but with commas if required (ie: 1,234 instead of 1234).
 *
 * @param {number} count - The number to format.
 * @param {number} [limit] - Limit before the number is abbreviated. (@default 10_000)
 */
export const formatCount = (count: number, limit: number = FORMAT_COUNT_LIMIT_DEFAULT) =>
  count >= limit ? abbrevNumber(count) : prettyNumber(count);
